import "./AppPageLoader.css";

export default function AppPageLoader({
  label = "Loading workspace",
  detail = "Preparing your latest data...",
}) {
  return (
    <div className="app-page-loader" role="status" aria-live="polite">
      <div className="app-page-loader-spinner" aria-hidden="true" />
      <div className="app-page-loader-copy">
        <strong>{label}</strong>
        <span>{detail}</span>
      </div>
    </div>
  );
}
